import { Link } from 'react-router-dom';

const steps = [
  {
    step: '01',
    icon: 'ri-discuss-line',
    title: '需求資訊',
    desc: '由專業業務人員對焦產品需求、目標市場、預算規劃等合作方向',
  },
  {
    step: '02',
    icon: 'ri-draft-line',
    title: '配方提案',
    desc: '根據配方需求，進行小批量試製確認品質與口感',
  },
  {
    step: '03',
    icon: 'ri-test-tube-line',
    title: '包裝設計',
    desc: '根據產品、配方原料性質，為產品量身打造包裝，提高產品的保存率',
  },
  {
    step: '04',
    icon: 'ri-file-check-line',
    title: '檢驗認證',
    desc: '若有相關檢驗、授權申請需求，可協助送審',
  },
  {
    step: '05',
    icon: 'ri-rocket-line',
    title: '量產確認',
    desc: '試樣通過後，將進入生產排程、正式量產',
  },
  {
    step: '06',
    icon: 'ri-ship-line',
    title: '完成交貨',
    desc: '完成品質檢驗後，將依約定時程安排出貨',
  },
];

export default function ProcessSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
            合作流程
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">
            六個步驟，輕鬆合作
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
            康永生技提供清晰透明的合作流程，讓您安心委託，快速上市
          </p>
        </div>

        <div className="relative">
          {/* Connector line - desktop */}
          <div className="hidden lg:block absolute top-10 left-[8%] right-[8%] h-0.5 bg-green-100 z-0" />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 relative z-10">
            {steps.map((s, idx) => (
              <div key={s.step} className="flex flex-col items-center text-center">
                <div className="relative mb-5">
                  <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-white border-2 border-[#4CAF50]">
                    <i className={`${s.icon} text-[#4CAF50] text-2xl`} />
                  </div>
                  <span className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center bg-[#4CAF50] text-white text-[0.6875rem] font-bold rounded-full">
                    {idx + 1}
                  </span>
                </div>
                <h3 className="text-[#1a2e1a] font-bold text-[1.0625rem] mb-2">{s.title}</h3>
                <p className="text-gray-500 text-[0.875rem] leading-[1.75]">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <Link
            to="/partnership"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[1rem] px-8 py-4 rounded-full transition-all duration-300 cursor-pointer"
          >
            了解合作詳情
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
